import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

import { useBreakpoint } from '../../../providers/BreakpointProvider'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  dash: {
    opacity: '0.1',
    height: '0.125rem',
    width: '8.125rem',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.altButtonText.main
  },

  title: {
    margin: '0 30px 0 37px',
    cursor: 'default',
    textAlign: 'center',
    color: theme.palette.altButtonText.main
  }
}))

const Title = ({ title, size }) => {
  const { isNotSmall } = useBreakpoint()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {isNotSmall && <div className={classes.dash} />}

      <div className={classes.title} style={{ fontSize: size }}>
        {title}
      </div>

      {isNotSmall && <div className={classes.dash} />}
    </div>
  )
}

export default Title
